import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'
import { useAccessHandbookLinks } from '@/queries/help_links/hooks.ts'
import MultiQueryPageLoader from '@/common/components/MultiQueryPageLoader.tsx'
import WalletHandbookLinkList from '@/pages/setup/link_handlers/wallet_handbook_link/components/WalletHandbookLinkList.tsx'

const WalletHandbookLinkPage = () => {
  const { selectedProgramYear } = useSelector(
    (state: RootState) => state.programs
  )

  const {
    query: handbookLinksQuery,
    invalidateQuery: invalidateHandbookLinks,
  } = useAccessHandbookLinks({
    globalOnId: 1,
    program_id: selectedProgramYear?.id ?? 0,
  })

  const handleHandbookLinkChange = () => invalidateHandbookLinks()

  return (
    <MultiQueryPageLoader
      showLoadingOnlyOnFirstFetch={true}
      queries={[handbookLinksQuery] as const}
    >
      {([handbookLinks]) => {
        return (
          <WalletHandbookLinkList
            invalidateHandbookLinks={invalidateHandbookLinks}
            handbookLinks={handbookLinks.data}
            onHandbookLinkChange={handleHandbookLinkChange}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
export default WalletHandbookLinkPage
